import React, { useState, useEffect, useRef } from "react";
import classNames from "classnames";
import { RichText } from "@sitecore-jss/sitecore-jss-react";
import { getOverallSettingsClasses } from "../../utils/siteUtils";
import { mobileIs } from "../../utils/siteUtils";
import PrimaryButton from "../../elements/primary-button";
import { BodyText } from "../../elements";
import { AnimatePresence, motion } from "framer-motion";
import "./style.scss";
import { gtag } from "../../utils";
import gsap from 'gsap';

const RegularService = props => {
	const { lang, rendering, fields, page } = props;
	const { colorScheme, iconName, buttonText, title, list } = fields;
	const isMobile = mobileIs()
	const rootNode = useRef()
	const titleEl = useRef()
	const [datalist, setDatalist] = useState([list]);
	const isAR = page?.fields?.rtl?.value;
	
	const toggleExpand = item => {
		let data = JSON.parse(JSON.stringify(list));
		const _item = list.find(x => x.id === item.id);
		_item.fields.open.value = !_item.fields.open.value;
		setDatalist(data);
	};
	
	useEffect(() => {
		
	}, [])
	
	const rootClasses = classNames("c-regular-service", getOverallSettingsClasses(fields));
	return (
		<div className={rootClasses} ref={rootNode} datasourceid={rendering.dataSource}>
			<div className="back">
				<PrimaryButton {...{
				  colorScheme: colorScheme,
				  iconName: iconName,
					buttonText: buttonText,
					callback: () => {
					  window.history.go(-1);
					}
				}} />
				<RichText tag="div" className="c-regular-service_title" field={title} />
				<div className="c-regular-service__items">
				  {list.map(item => (
				    <RegularServiceItem {...{ item, toggleExpand }} key={item.id} />
				  ))}
				</div>
			</div>
		</div>
	)
}

const RegularServiceItem = ({ item, toggleExpand }) => {
  const { carModel, detail, open } = item.fields;
  const itemAnimation = {
    initial: "collapsed",
    animate: "open",
    exit: "collapsed",
    variants: {
      open: { opacity: 1, height: "auto" },
      collapsed: { opacity: 0, height: 0 }
    },
    transition: { duration: 0.8, ease: [0.04, 0.62, 0.23, 0.98] }
  };
  return (
    <div className="c-regular-service__item">
      <div className="c-regular-service__item-header" onClick={e => toggleExpand(item)}>
        <BodyText html={carModel} className="c-regular-service__item-title__f-h4" tagName="h4" />
        <i className={classNames("c-regular-service__item-trigger", { active: open?.value })} />
      </div>
      <AnimatePresence>
        {open?.value && (
          <motion.div className="c-regular-service__item-answer" {...itemAnimation}>
            <BodyText html={detail} />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default 	RegularService;